import { formatValidQueryParamUrlCommaSeparated } from "utils/common";



import { sunoCommsApi } from "./api-base";
import type { ContactInboxInfo, ContactMessage, ContactMessageFilters, ContactRawMessage, EmailMessage, EmailMessageRequest, EmailMessageResponse, LeadContactMessageInput } from "./types/lead-contact-message.type";
import type { LeadContactConversation } from "./types/lead-contact.conversation.type";
import { formatContactInbox, formatContactMessage } from "./utils/messages-utils";





export const MESSAGES_LIMIT = 50;

export const leadMessagesApi = sunoCommsApi.injectEndpoints({
  overrideExisting: true,
  endpoints: (builder) => ({
    addMessage: builder.mutation<ContactRawMessage, LeadContactMessageInput>({
      query: (messageData) => ({
        url: "/messages/",
        method: "POST",
        body: messageData
      }),
      invalidatesTags: ["LeadMessages", "LeadContacts", "LeadContactsCount"]
    }),
    sendEmail: builder.mutation<EmailMessageResponse, EmailMessageRequest>({
      query: (messageData) => ({
        url: "/email-messages/",
        method: "POST",
        body: messageData
      }),
      invalidatesTags: [
        "LeadMessages",
        "LeadEmails",
        "LeadContacts",
        "LeadEmailMessages",
        "LeadContactsCount"
      ]
    }),

    readAllContactMessages: builder.mutation<void, string>({
      query: (contactId) => ({
        url: `/messages/read?contact_id=${contactId}`,
        method: "POST"
      }),
      invalidatesTags: ["LeadMessages"]
    }),
    getUnreadMessagesCount: builder.query<number, void>({
      query: () => "/messages/unread-messages-count",
      transformResponse: (response: { count: number }) => {
        return Number(response?.count || 0);
      },
      providesTags: ["LeadMessagesCount"]
    }),
    getMessagesByContactId: builder.query<
      ContactMessage[],
      ContactMessageFilters
    >({
      query: (filters) =>
        `/messages/${formatValidQueryParamUrlCommaSeparated(filters, true)}`,
      providesTags: ["LeadMessages"],
      transformResponse: (response: ContactRawMessage[]) => {
        return response.map((message) => formatContactMessage(message));
      }
    }),
    getEmailMessages: builder.query<
      EmailMessage[],
      {
        id?: string;
        contact_id?: string;
      }
    >({
      query: (filters) =>
        `/email-messages/${formatValidQueryParamUrlCommaSeparated(
          filters,
          true
        )}`,
      providesTags: ["LeadEmailMessages"]
    }),
    getContactsInbox: builder.query<
      LeadContactConversation[],
      {
        offset?: number;
        limit?: number;
        contact_id?: string;
      }
    >({
      query: ({ offset = 0, limit = MESSAGES_LIMIT, ...rest }) =>
        `/messages/contacts/inbox${formatValidQueryParamUrlCommaSeparated(
          { offset, limit, ...rest },
          true
        )}`,
      providesTags: ["LeadInbox"],
      transformResponse: (response: { contact: ContactInboxInfo }[]) => {
        return response.map((info) => formatContactInbox(info.contact));
      }
    })
    //
  })
});

export const {
  useAddMessageMutation,
  useSendEmailMutation,
  useReadAllContactMessagesMutation,
  useGetUnreadMessagesCountQuery,
  useGetMessagesByContactIdQuery,
  useGetContactsInboxQuery,
  useLazyGetContactsInboxQuery,
  useGetEmailMessagesQuery
} = leadMessagesApi;